//* jQuery is not enqueued on this website, so only vanilla JS will work, if there's need for jQuery you will need to add it as dependency on functions.php

// NAV TOGGLE
(function () {
	const mobileToggle = document.querySelector("#mobile-toggle");
	const mobileNav = document.querySelector("#mobile-nav");
	const header = document.querySelector(".app-header");

	mobileToggle.addEventListener("click", function () {
		this.classList.toggle("active");
		header.classList.toggle("mobile-nav-active");
		mobileNav.classList.toggle("active");
	});
})();

// SHOW / HIDE HEADER ON SCROLL
(function () {
	const header = document.querySelector(".app-header");
	let lastScroll = window.scrollY || document.documentElement.scrollTop;

	// Helper function to get the scroll direction
	const getScrollDirection = (currentScroll, lastScroll) => {
		return currentScroll > lastScroll ? "down" : "up";
	};

	// Helper function to throttle scroll event
	const throttleScroll = (callback, delay) => {
		let isThrottled = false;

		return function () {
			if (!isThrottled) {
				callback.apply(this, arguments);
				isThrottled = true;

				setTimeout(function () {
					isThrottled = false;
				}, delay);
			}
		};
	};

	// Update header style depending on scroll position
	const updateHeader = () => {
		const currentScroll =
			window.pageYOffset || document.documentElement.scrollTop;
		const scrollDirection = getScrollDirection(currentScroll, lastScroll);

		if (currentScroll > 100) {
			header.classList.add("app-header--scrolled");
		} else {
			header.classList.remove("app-header--scrolled");
		}

		if ((currentScroll > 200) & (scrollDirection === "down")) {
			header.classList.add("app-header--hide");
		} else {
			header.classList.remove("app-header--hide");
		}

		lastScroll = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
	};

	// Call update header once to apply the correct classes if header is already scrolled when loading page
	updateHeader();

	// Call udpate header on scroll
	window.addEventListener("scroll", throttleScroll(updateHeader, 40), false);
})();

// MODALS
(function () {
	const modals = document.querySelectorAll(".modal");
	let container = document.querySelector(".search__container");

	if (!modals.length) return;

	const eventCarousel = document.querySelector(".event-carousel");
	if (eventCarousel) {
		container = eventCarousel;
	}

	if (!container) return;

	container.addEventListener("click", function (e) {
		if (e.target.classList.contains("btn-request-copy")) {
			e.preventDefault();
			const card = e.target.closest(".travere-card");
			const publicationText =
				card.querySelector(".card__title")?.textContent || "";
			const formTitle = document.querySelector(
				'input.wpcf7-form-control[name="request-title"]',
			);
			formTitle.value = publicationText;

			const modal = document.getElementById("modal-request-copy");
			if (modal) {
				modal.style.display = "block";
				modal.classList.remove("close");
			}
		}

		if (e.target.classList.contains("btn-leaving")) {
			e.preventDefault();
			const link = e.target.getAttribute("data-url");

			const modal = document.getElementById("modal-leaving");
			if (modal) {
				modal.style.display = "block";
				modal.classList.remove("close");

				const linkButton = modal.querySelector(".btn-leaving-link");
				linkButton.href = link;
			}
		}
	});

	modals.forEach((modal) => {
		const buttonClose = modal.querySelectorAll(".btn-close");
		const modalBackdrop = modal.querySelector(".modal__backdrop");

		buttonClose.forEach((button) => {
			button.addEventListener("click", function (e) {
				e.preventDefault();
				modal.classList.add("close");
				modal.style.display = "none";
			});
		});

		if (modalBackdrop && modal.id !== "modal-intro") {
			modalBackdrop.addEventListener("click", function (e) {
				if (e.target === modalBackdrop) {
					e.preventDefault();
					modal.classList.add("close");
					modal.style.display = "none";
				}
			});
		}

		if (modal.id === "modal-intro") {
			const modalClicked = document.cookie.includes("modalClicked=true");

			if (!modalClicked) {
				const modalButton = modal.querySelector(".btn-intro-close");
				modal.style.display = "block";

				modalButton.addEventListener("click", function () {
					modal.classList.add("close");
					modal.style.display = "none";
					setTimeout(() => {
						// Set a cookie that expires in 1 day
						const expirationDate = new Date();
						expirationDate.setDate(expirationDate.getDate() + 1);
						document.cookie =
							"modalClicked=true; expires=" +
							expirationDate.toUTCString() +
							"; path=/";
					}, 300);
				});
			}
		}
	});
})();

// POST CAROUSEL
(function () {
	const carousels = document.querySelectorAll(".carousel-posts");

	if (!carousels.length) {
		return;
	}

	carousels.forEach((carousel) => {
		new Swiper(carousel, {
			loop: false,
			slidesPerView: 1,
			centeredSlides: false,
			spaceBetween: 20,
			mousewheel: true,
			pagination: {
				el: ".swiper-pagination",
				type: "progressbar",
			},
			breakpoints: {
				600: {
					slidesPerView: 2,
				},
				1000: {
					slidesPerView: 3,
				},
			},
		});
	});
})();

// FILTER COLLAPSE
(function () {
	const headers = document.querySelectorAll(".search-filters__group--header");

	headers.forEach((header) => {
		header.addEventListener("click", function () {
			this.parentElement.classList.toggle("active");
		});
	});
})();

// TABS
(function () {
	const tabsWrappers = document.querySelectorAll(".tabs-wrapper");
	const tabButtons = document.querySelectorAll(".tab-btn");
	const hash = window.location.hash;

	if (tabsWrappers.length === 0) {
		return;
	}

	function initializeTabs() {
		if (hash) {
			tabsWrappers.forEach((wrapper) => {
				const hashValue = hash.slice(1);
				const targetTabBtn = document.querySelector(
					`.tab-btn[data-target-tab="${hashValue}"]`,
				);
				const targetTabBtnIndex = Array.from(tabButtons).indexOf(targetTabBtn);
				tabButtons.forEach((btn) => btn.classList.remove("active-tab"));
				targetTabBtn.classList.add("active-tab");

				const panels = wrapper.querySelectorAll(".tab-panel");
				panels.forEach((panel) => panel.classList.remove("active"));
				panels[targetTabBtnIndex].classList.add("active");
			});
		} else {
			tabsWrappers.forEach((wrapper) => {
				const activeTabBtn = wrapper.querySelector(".tab-btn.active-tab");
				const activeTabIndex = Array.from(tabButtons).indexOf(activeTabBtn);

				if (activeTabIndex !== -1) {
					const panels = wrapper.querySelectorAll(".tab-panel");
					panels.forEach((panel) => panel.classList.remove("active"));
					panels[activeTabIndex].classList.add("active");
				}
			});
		}
	}

	function handleTabClick(event) {
		const tabBtn = event.target;
		const wrapper = tabBtn.closest(".tabs-wrapper");
		const activeTabIndex = Array.from(tabButtons).indexOf(tabBtn);

		tabButtons.forEach((btn) => btn.classList.remove("active-tab"));
		tabBtn.classList.add("active-tab");

		const panels = wrapper.querySelectorAll(".tab-panel");
		panels.forEach((panel) => panel.classList.remove("active"));
		panels[activeTabIndex].classList.add("active");

		const mobileQuery = window.matchMedia("(max-width: 767px)");
		if (mobileQuery.matches) {
			panels[activeTabIndex].scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		}
	}

	initializeTabs();

	tabButtons.forEach((tabBtn) => {
		tabBtn.addEventListener("click", handleTabClick);
	});
})();

// FILTER MOBILE TOGGLE AND SCROLL
(function () {
	const filterMobile = document.querySelector(".filters-mobile");
	const button = document.getElementById("filters-mobile-toggle");
	const filters = document.getElementById("filters-panel");
	const close = document.getElementById("filter-mobile-close");

	if (!button) return;

	button.addEventListener("click", (e) => {
		e.preventDefault();
		filters.classList.toggle("active");
	});

	close.addEventListener("click", (e) => {
		e.preventDefault();
		filters.classList.remove("active");
	});

	function handleScroll() {
		var wScroll = window.scrollY || window.pageYOffset;
		if (wScroll >= 200) {
			filterMobile.classList.add("--scrolled");
		} else {
			filterMobile.classList.remove("--scrolled");
		}
	}

	window.addEventListener("scroll", handleScroll);
	window.addEventListener("load", handleScroll);

	handleScroll();
})();

// SEARCH
// (function () {
// 	function validateForm() {
// 		var inputElement = document.querySelector('[name="t"]');
// 		var inputValue = inputElement.value.trim(); // Get the input value and trim it

// 		if (inputValue === "") {
// 			// Display an error message or perform any other desired action
// 			alert("Please enter a search term.");
// 			return false; // Prevent form submission
// 		}

// 		// If the input is not empty, the form will be submitted
// 		return true;
// 	}

// 	// Add an event listener for form submission
// 	var form = document.querySelector(".search__form");
// 	if (form) {
// 		form.addEventListener("submit", function (event) {
// 			if (!validateForm()) {
// 				event.preventDefault(); // Prevent the form from submitting if validation fails
// 			}
// 		});
// 	}
// })();
